import React from 'react'
import { withRouter } from 'react-router-dom'

import { Calendar } from 'primereact/calendar'
import { Toast } from 'primereact/toast'
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import PublicacoesService from '../../app/service/PublicacoesService'
import PaginaPublicacaoDetalhada from './PaginaPublicacaoDetalhada';
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import StatusProcessualService from '../../app/service/StatusProcessualService'
import AreaAtuacaoService from '../../app/service/AreaAtuacaoService'

class Publicacoes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openSpinner: false,
      publicacoes: [],
      consultaDataInicial: '',
      consultaDataFinal: '',
      consultaPessoa: '',
      consultaAdvogado: '',
      consultaProcesso: '',
			consultaPorPublicacaoLida: null,
			gruposTrabalho: [],
			consultaGrupoTrabalho: null,
			statusProcessuais: [],
			consultaStatusProcessual: null,
			areasAtuacao: [],
			areaAtuacao: null,
			tribunais: [],
			tribunal: null,
			//Filtro da última consulta feita: os gráficos acompanham o resultado dela
			filtroAplicado: null,
		}

    this.publicacoesService = new PublicacoesService();
		this.statusProcessualService = new StatusProcessualService();
		this.grupoTrabalhoService = new GrupoTrabalhoService();
		this.areaAtuacaoService = new AreaAtuacaoService();

    this.destinatarios = this.destinatarios.bind(this);
    this.advogados = this.advogados.bind(this);

		this.lidasOptions = [
			{codigo: 'T', nome: 'Todos'},
			{codigo: 'L', nome: 'Lidas'},
			{codigo: 'N', nome: 'Não Lidas'}
		]
  }

	listarAreasAtuacao = async () => {
		const usuario = this.context.usuarioAutenticado;
		await this.areaAtuacaoService.listarAreaAtuacao(usuario.empresa.codigo)
			.then(response => {
				this.setState({areasAtuacao: response.data});
				this.setState({areaAtuacao: response.data});
			}).catch(error => {
				this.toast.show({severity:'error', summary: 'Publicações', detail:'Erro ao carregar Áreas de Atuação', life: 4000});
			})
	}

	listarTribunais = async () => {
		const usuario = this.context.usuarioAutenticado;
		await this.publicacoesService.buscarTribunais(usuario.empresa.codigo)
			.then(response => {
				this.setState({tribunais: response.data});
				this.setState({tribunal: response.data});
			}).catch(error => {
				this.toast.show({severity:'error', summary: 'Publicações', detail:'Erro ao carregar Tribunais', life: 4000});
			})
	}

	listarStatusProcessual = () => {
    const usuario = this.context.usuarioAutenticado;
		this.statusProcessualService.listarStatusProcessual(usuario.empresa.codigo)
      .then(response => {
        this.setState({statusProcessuais: response.data});
				this.setState({consultaStatusProcessual: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Publicações', detail:'Erro ao carregar Status Processual', life: 4000});
      })
  }

	listarGruposTrabalho = () => {
    const usuario = this.context.usuarioAutenticado;
		this.grupoTrabalhoService.listarGruposUsuario(usuario.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
				this.setState({consultaGrupoTrabalho: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      });
  }

  //Data apagada no Calendar vira null (e não ''): só conta como informada se tiver valor
  dataInformada = (data) => data !== null && data !== undefined && data !== '';

  consultarPublicacoes = async () => {
    const filtro = this.montarFiltro();
    if (filtro == null) {
      return;
    }

		//localStorage.setItem("filtroPublicacoes", JSON.stringify(filtro));

    this.setState({openSpinner: true});

    await this.publicacoesService.consultarPublicacoes(filtro)
      .then(response => {
		    this.setState({publicacoes: response.data, filtroAplicado: filtro});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
      })
  }

  //Monta o filtro da consulta; null (com aviso) se faltar período e processo/pessoa/advogado
  montarFiltro = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const temDataInicial = this.dataInformada(this.state.consultaDataInicial);
    const temDataFinal = this.dataInformada(this.state.consultaDataFinal);
    if (temDataInicial !== temDataFinal) {
      this.toast.show({severity:'warn', summary: 'Publicações', detail:'Informe as duas datas do período', life: 4000});
      return null;
    }
    var dataInicial = '';
    var dataFinal = '';
    if(temDataInicial && temDataFinal) {
      dataInicial = this.formatarData(this.state.consultaDataInicial);
      dataFinal = this.formatarData(this.state.consultaDataFinal);
    }

    //O número do processo é gravado só com dígitos
    const numeroProcesso = (this.state.consultaProcesso || '').replace(/\D/g, '');
    const pessoa = (this.state.consultaPessoa || '').trim();
    const advogado = (this.state.consultaAdvogado || '').trim();
    if (dataInicial === '' && numeroProcesso === '' && pessoa === '' && advogado === '') {
      this.toast.show({severity:'warn', summary: 'Publicações', detail:'Informe o período ou um processo, pessoa ou advogado', life: 4000});
      return null;
    }

		var lidas = 'T';
		if(this.state.consultaPorPublicacaoLida != null) {
			lidas = this.state.consultaPorPublicacaoLida.codigo;
		}

		//Status Processual
    var status = "";
		if(this.state.consultaStatusProcessual == null) {
			status = "";
		} else if(this.state.consultaStatusProcessual != null && 
			this.state.consultaStatusProcessual.length === this.state.statusProcessuais.length) {
				status = "";
		} else {
			var contador = 0;
			for(let i = 0; i < this.state.consultaStatusProcessual.length; i++) {
				if(contador < this.state.consultaStatusProcessual.length - 1) {
					status = status + this.state.consultaStatusProcessual[i].codigo + ',';
				} else {
					status = status + this.state.consultaStatusProcessual[i].codigo;
				}
				contador++;
			}
    }

		//Grupos de Trabalho
    var grupos = "";
		if(this.state.consultaGrupoTrabalho == null) {
			grupos = "";
		} else if(this.state.consultaGrupoTrabalho != null && 
			this.state.consultaGrupoTrabalho.length === this.state.gruposTrabalho.length) {
				grupos = "";
		} else {
      var contador = 0;
      for(let i = 0; i < this.state.consultaGrupoTrabalho.length; i++) {
        if(contador < this.state.consultaGrupoTrabalho.length - 1) {
          grupos = grupos + this.state.consultaGrupoTrabalho[i].codigo + ',';
        } else {
          grupos = grupos + this.state.consultaGrupoTrabalho[i].codigo;
        }
        contador++;
      }
    }

		//Tribunais
		var tribunais = "";
		if(this.state.tribunal == null) {
			tribunais = "";
		} else if(this.state.tribunal != null && this.state.tribunal.length === this.state.tribunais.length) {
			tribunais = "";
		} else {
			var contador = 0;
      for(let i = 0; i < this.state.tribunal.length; i++) {
        if(contador < this.state.tribunal.length - 1) {
          tribunais = tribunais + '"' + this.state.tribunal[i].codigo + '",';
        } else {
          tribunais = tribunais + '"' + this.state.tribunal[i].codigo + '"';
        }
        contador++;
      }
		}

		//Tribunais
		var areas = "";
		if(this.state.areaAtuacao == null) {
			areas = "";
		} else if(this.state.areaAtuacao != null && this.state.areaAtuacao.length === this.state.areasAtuacao.length) {
			areas = "";
		} else {
			var contador = 0;
      for(let i = 0; i < this.state.areaAtuacao.length; i++) {
        if(contador < this.state.areaAtuacao.length - 1) {
          areas = areas + this.state.areaAtuacao[i].codigo + ',';
        } else {
          areas = areas + this.state.areaAtuacao[i].codigo;
        }
        contador++;
      }
		}

    return {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      pessoa: pessoa,
      advogado: advogado,
      numeroProcesso: numeroProcesso,
			usuario: usuarioLogado.codigo,
			publicacoesLidas: lidas,
      empresa: usuarioLogado.empresa.codigo,
			gruposTrabalho: grupos,
			statusProcessuais: status,
			tribunais: tribunais,
			areasAtuacao: areas
    }
  }

  formatarData = (data) => {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  };

  consultarInicial = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const hoje = new Date();
		const dataFormatada =
			hoje.getFullYear() + '-' +
			String(hoje.getMonth() + 1).padStart(2,'0') + '-' +
			String(hoje.getDate()).padStart(2,'0');
		this.setState({consultaDataInicial: hoje});
		this.setState({consultaDataFinal: hoje});
    const filtro = {
      dataInicial: dataFormatada,
      dataFinal: dataFormatada,
      pessoa: "",
      advogado: "",
      numeroProcesso: "",
			publicacoesLidas: 'T',
			usuario: usuarioLogado.codigo,
      empresa: usuarioLogado.empresa.codigo,
			statusProcessuais: "",
			gruposTrabalho: "",
			tribunais: "",
			areasAtuacao: ""
    }

		//localStorage.setItem("filtroPublicacoes", JSON.stringify(filtro));
  	this.setState({openSpinner: true});
    
		await this.publicacoesService.consultarPublicacoes(filtro)
      .then(response => {
        this.setState({publicacoes: response.data, filtroAplicado: filtro});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        console.log('Erororororororororo caius ', error);
				//this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
      })
  }

  destinatarios(rowData) {
    return(
      <React.Fragment>
        <Button icon="far fa-user" className="p-button-rounded p-button-text"
                tooltip="Incluir no Histórico"
                onClick={() => this.confirmaIncluirHistorico(rowData)}
                disabled={rowData.temHistorico == 'S' ? false : true}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  advogados(rowData) {
    return(
      <React.Fragment>
        <Button icon="fa fa-user-tie" className="p-button-rounded p-button-text"
                tooltip="Incluir no Histórico"
                onClick={() => this.confirmaIncluirHistorico(rowData)}
                disabled={rowData.temHistorico == 'S' ? false : true}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  async componentDidMount() {
		this.listarStatusProcessual();
		this.listarGruposTrabalho();
		this.listarAreasAtuacao();
		this.listarTribunais();
    this.consultarInicial();
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#9a0e0e', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fa fa-clipboard-list"></i>
                        <span> Publicações</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-2">
                          <div className="form-group">
                            <Calendar id="idConsultaPorDataInicial" 
                                      value={this.state.consultaDataInicial} 
                                      onChange={(e) => this.setState({ consultaDataInicial: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      placeholder="Dt Inicial"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <Calendar id="idConsultaPorDataFinal" 
                                      value={this.state.consultaDataFinal} 
                                      onChange={(e) => this.setState({ consultaDataFinal: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      placeholder="Dt Final"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                            <InputText id="consultaProcesso" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.consultaProcesso}
                                      onChange={e => this.setState({consultaProcesso: e.target.value})}
                                      placeholder="Número do Processo"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <InputText id="consultaPessoa" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.consultaPessoa}
                                      onChange={e => this.setState({consultaPessoa: e.target.value})}
                                      placeholder="Pessoa"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
												<div className="col-md-2">
													<div className="form-group">
														<Dropdown value={this.state.consultaPorPublicacaoLida} 
																			options={this.lidasOptions} style={{width: '100%', height: '32px'}}
																			optionLabel="nome" 
																			emptyMessage=" "
																			placeholder="Lidas/Não Lidas"
																			filter showClear filterBy="nome"
																			onChange={e => this.setState({consultaPorPublicacaoLida: e.target.value})}
																			id="lidaPublicacao"
																			className="p-inputtext-sm p-d-block p-mb-1"/>
													</div>
												</div>
											</div>
											<div className="row">
                        <div className="col-md-2">
                          <div className="form-group">
                            <InputText id="consultarAdvogado" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.consultaAdvogado}
                                      onChange={e => this.setState({consultaAdvogado: e.target.value})}
                                      placeholder="Advogado"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
												<div className="col-md-2">
													<div className="form-group">
														<MultiSelect inputId="grupoTrabalho" 
																			   value={this.state.consultaGrupoTrabalho} 
																				 options={this.state.gruposTrabalho} 
																				 style={{width: '100%', height: '32px', padding_top: '1px'}} 
																				 onChange={(e) => this.setState({ consultaGrupoTrabalho: e.value })} 
																				 filter showClear filterBy="nome"
																				 optionLabel="nome" />
													</div>
												</div>
												<div className="col-md-2">
													<div className="form-group">
														<MultiSelect inputId="statusProcessual" 
																			   value={this.state.consultaStatusProcessual} 
																				 options={this.state.statusProcessuais} 
																				 style={{width: '100%', height: '32px', padding_top: '1px'}} 
																				 onChange={(e) => this.setState({ consultaStatusProcessual: e.value })} 
																				 filter showClear filterBy="descricao"
																				 optionLabel="descricao" />
													</div>
												</div>
                        <div className="col-md-2">
                          <div className="form-group">
														<MultiSelect inputId="areaAtuacao" 
																			   value={this.state.areaAtuacao} 
																				 options={this.state.areasAtuacao} 
																				 style={{width: '100%', height: '32px', padding_top: '1px'}} 
																				 onChange={(e) => this.setState({ areaAtuacao: e.value })} 
																				 filter showClear filterBy="nome"
																				 optionLabel="nome" />
													</div>
												</div>
												<div className="col-md-2">
                          <div className="form-group">
														<MultiSelect inputId="tribunais" 
																			   value={this.state.tribunal} 
																				 options={this.state.tribunais} 
																				 style={{width: '100%', height: '32px', padding_top: '1px'}} 
																				 onChange={(e) => this.setState({ tribunal: e.value })} 
																				 filter showClear filterBy="nome"
																				 optionLabel="nome" />
													</div>
												</div>
                        <div className="col-md-1">
                          <div className="form-group">
                            <Button style={{height: '32px'}} type="button" className="p-button-info p-button-sm" 
                                  onClick={this.consultarPublicacoes}>
                              <i className="fas fa-search"></i>&nbsp;&nbsp;Consultar</Button>
                          </div>
                        </div>
                      </div>
											<br></br>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <PaginaPublicacaoDetalhada
																publicacoes={this.state.publicacoes}
																setPublicacoes={(novasPublicacoes) =>
																	this.setState({ publicacoes: novasPublicacoes })
																}
																filtro={this.state.filtroAplicado}
														/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

Publicacoes.contextType = AuthContext;
export default withRouter (Publicacoes)